export const MAX_DIMENSION = 8192;

export const isValidDimension = (n: number) => Number.isFinite(n) && n > 0 && n <= MAX_DIMENSION;

export const isValidResolution = ({ width, height }: Resolution): boolean =>
	isValidDimension(width) && isValidDimension(height);
